document.addEventListener("DOMContentLoaded", () => {
  const initializedSections = new Set();

  document.querySelectorAll(".featured-offers").forEach(section => {
    const sectionId = section.dataset.sectionId;
    if (!sectionId || initializedSections.has(sectionId)) return;
    initializedSections.add(sectionId);

    const wrap = section.querySelector(".featured-offers-wrapper");
    if (wrap) initializeFeaturedOffers(section, sectionId, wrap);
  });
});

/* ----
   FEATURED OFFERS INITIALIZER
---- */
function initializeFeaturedOffers(section, sectionId, wrap) {
  console.log(`🎯 Featured Offers initialized for: ${sectionId}`);

  /* 
     IMAGE ZOOM MODAL
   */
  section.querySelectorAll(".offer-image img").forEach(img => {
    img.addEventListener("click", () => {
      const modal = document.createElement("div");
      Object.assign(modal.style, {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(0,0,0,0.8)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "99999",
        cursor: "zoom-out"
      });
      modal.innerHTML = `<img src="${img.src}" style="max-width:90%;max-height:90%;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,0.6);" />`;
      modal.addEventListener("click", () => modal.remove());
      document.body.appendChild(modal);
    });
  });

  /* 
     AUTO STOCK CHECK FOR BUNDLE DEALS
   */
  wrap.querySelectorAll(".offer-item").forEach(async item => {
    const lowStockTextEl = item.querySelector(".low-stock-text");
    const bundleHandles = [item.dataset.bundle1, item.dataset.bundle2, item.dataset.bundle3]
      .filter(h => h && h !== "null" && h !== "undefined");
    if (bundleHandles.length === 0) return;

    let unavailable = false;
    let lowStockCount = null;
    let validFetchCount = 0;

    for (const handle of bundleHandles) {
      try {
        const r = await fetch(`/products/${handle}.js`);
        if (!r.ok) continue;
        const data = await r.json();
        if (!data.variants?.length) continue;

        validFetchCount++;
        const firstVariant = data.variants[0];
        const qty = firstVariant.inventory_quantity ?? null;
        const managesInventory = firstVariant.inventory_management !== null;

        if (!firstVariant.available || (managesInventory && qty !== null && qty <= 0)) {
          unavailable = true;
          break;
        }
        if (managesInventory && qty !== null && qty > 0 && qty <= 5) {
          lowStockCount = lowStockCount ? Math.min(lowStockCount, qty) : qty;
        }
      } catch (err) {
        console.warn("Stock check failed:", handle, err);
      }
    }

    if (validFetchCount > 0) {
      if (unavailable) {
        item.classList.add("offer-unavailable");
        const btns = item.querySelectorAll("button, a.button");
        btns.forEach(b => {
          const isShare = b.classList.contains("share-toggle");
          if (isShare) {
            b.style.pointerEvents = "none";
            b.style.opacity = "0.4";
            b.style.cursor = "default";
          } else {
            b.disabled = true;
            b.style.pointerEvents = "none";
            b.style.opacity = "0.6";
            b.textContent = "Unavailable";
            b.style.cursor = "not-allowed";
          }
        });
      } else if (lowStockCount) {
        item.classList.add("low-stock");
        if (lowStockTextEl) {
          const styleType = lowStockTextEl.dataset.lowstockStyle;
          if (styleType === "above_button") {
            lowStockTextEl.innerHTML = `Only ${lowStockCount} bundles left 🔥`;
          } else if (styleType === "badge") {
            const title = item.querySelector("h3");
            if (title) {
              const badge = document.createElement("span");
              badge.className = "low-stock-badge";
              badge.textContent = `Only ${lowStockCount} left!`;
              title.appendChild(badge);
            }
          }
        }
      }
    }
  });

  /* 
     GRID + FILTERING SYSTEM
   */
  wrap.classList.add("featured-offers-grid");
/* 
   VARIANT SWATCH INITIALIZATION (Image-based)
 */
section.querySelectorAll(".offer-item").forEach(item => {
  const btn = item.querySelector(".add-to-cart-btn");
  const swatches = item.querySelectorAll(".variant-swatch-circle");
  const label = item.querySelector(".variant-selected");

  if (swatches.length > 0 && btn) {
    swatches.forEach(swatch => {
      swatch.addEventListener("click", () => {
        swatches.forEach(s => s.classList.remove("active"));
        swatch.classList.add("active");
        btn.dataset.variantId = swatch.dataset.variantId;
        if (label) label.textContent = swatch.dataset.variantTitle;
      });
    });
  }
});


  const typeButtons = section.querySelectorAll("[data-filter-type]");
  const ageButtons = section.querySelectorAll("[data-filter-age]");
  const offerItems = section.querySelectorAll(".offer-item");

  let currentType = "all";
  let currentAge = "all";

  function filterOffers(updateURL = true) {
    offerItems.forEach(item => {
      const type = item.dataset.category;
      const age = item.dataset.age;
      const matchesType = currentType === "all" || type === currentType;
      const matchesAge = currentAge === "all" || age === currentAge;
      item.style.display = (matchesType && matchesAge) ? "" : "none";
    });

    const visibleItems = [...offerItems].filter(i => i.style.display !== "none");
    let noResultsMsg = section.querySelector(".no-results");
    if (visibleItems.length === 0) {
      if (!noResultsMsg) {
        noResultsMsg = document.createElement("p");
        noResultsMsg.className = "no-results";
        noResultsMsg.textContent = "Check back next week! New deals drop weekly.";
        wrap.insertAdjacentElement("afterend", noResultsMsg);
      }
    } else {
      noResultsMsg?.remove();
    }

    if (updateURL) {
      const params = new URLSearchParams(window.location.search);
      if (currentType !== "all") params.set("type", currentType); else params.delete("type");
      if (currentAge !== "all") params.set("age", currentAge); else params.delete("age");
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
  }

  function activateButton(buttons, value, dataAttr) {
    buttons.forEach(b => {
      const attr = b.dataset[dataAttr];
      b.classList.toggle("active", attr === value);
    });
  }

  typeButtons.forEach(btn => {
    btn.addEventListener("click", e => {
      e.preventDefault();
      const selectedType = btn.dataset.filterType;
      btn.blur();

      if (currentType === selectedType) {
        currentType = "all";
        typeButtons.forEach(b => b.classList.remove("active"));
        const allBtn = section.querySelector('[data-filter-type="all"]');
        allBtn?.classList.add("active");
      } else {
        currentType = selectedType;
        typeButtons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
      }

      requestAnimationFrame(() => btn.blur());
      filterOffers(true);
    });
  });

  ageButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const selectedAge = btn.dataset.filterAge;
      if (currentAge === selectedAge) {
        currentAge = "all";
        ageButtons.forEach(b => b.classList.remove("active"));
      } else {
        currentAge = selectedAge;
        ageButtons.forEach(b => b.classList.remove("active"));
        btn.classList.add("active");
      }
      filterOffers(true);
    });
  });

  const params = new URLSearchParams(window.location.search);
  const typeFromUrl = params.get("type");
  const ageFromUrl = params.get("age");
  if (typeFromUrl) {
    currentType = typeFromUrl;
    activateButton(typeButtons, typeFromUrl, "filterType");
  }
  if (ageFromUrl) {
    currentAge = ageFromUrl;
    activateButton(ageButtons, ageFromUrl, "filterAge");
  }
  filterOffers(false);

  /* 
     SMART AJAX ADD TO CART (Instant Refresh)
   */
  wrap.addEventListener("click", async e => {
    const btn = e.target.closest(".add-to-cart-btn");
    if (!btn) return;


    const item = btn.closest(".offer-item");
    const bundleHandles = [item.dataset.bundle1, item.dataset.bundle2, item.dataset.bundle3]
      .filter(h => h && h !== "null" && h !== "undefined");

    let variantId = null;

   try {
  // 🔹 Use user-selected variant first (from swatches)
  variantId = btn.dataset.variantId && btn.dataset.variantId !== "undefined"
    ? btn.dataset.variantId
    : null;

  // 🔹 If no variant selected and bundle handles exist, fall back to first variant of bundle
  if (!variantId && bundleHandles.length > 0) {
    const res = await fetch(`/products/${bundleHandles[0]}.js`);
    const data = await res.json();
    variantId = data?.variants?.[0]?.id || null;
  }
} catch (err) {
  console.warn("Error resolving variant ID:", err);
}


    if (!variantId) {
      alert("⚠️ No valid product found for this offer. Please check the section setup.");
      return;
    }

    let qty = parseInt(btn.dataset.qty || "1", 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    btn.disabled = true;
    btn.textContent = "Adding...";

fetch(`${window.Shopify.routes.root}cart/add.js`, {
  method: "POST",
  credentials: "same-origin",
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  },
  body: JSON.stringify({ id: variantId, quantity: qty })
})

.then(async () => {
  btn.textContent = "Added!";
  btn.disabled = false;

  // 🔥 This triggers the Taiga cart drawer refresh
  setTimeout(() => document.dispatchEvent(new CustomEvent("ajaxProduct:added")), 250);

  setTimeout(() => (btn.textContent = "Add to Cart"), 2000);
})

  .catch(err => {
    console.error("Add to cart failed:", err);
    btn.textContent = "Error";
    btn.disabled = false;
  });




  });

  /* 
     SHARE POPUP & COPY LINK
   */
  document.addEventListener("click", e => {
    const isToggle = e.target.closest(".share-toggle");
    const popups = section.querySelectorAll(".share-popup");
    popups.forEach(p => p.classList.remove("show"));
    if (isToggle) {
      const popup = isToggle.parentElement.querySelector(".share-popup");
      popup.classList.add("show");
      e.stopPropagation();
    }
  });

  section.querySelectorAll(".share-option.copy").forEach(btn => {
    btn.addEventListener("click", async () => {
      const link = btn.dataset.url;
      try {
        await navigator.clipboard.writeText(link);
        btn.textContent = "Copied!";
        setTimeout(() => (btn.textContent = "Copy Link"), 2000);
      } catch {
        prompt("Copy this link:", link);
      }
    });
  });

  /* 
     CART DRAWER SAFETY
   */
  const observer = new MutationObserver(() => {
    const cartDrawer = document.querySelector('[x-show="cartOpen"], .cart-drawer, [data-drawer="cart"]');
    const isOpen =
      (cartDrawer && (cartDrawer.style.display !== "none" && cartDrawer.offsetParent !== null)) ||
      document.body.classList.contains("drawer-open");

    const shareTriggers = section.querySelectorAll(".offer-share-trigger, .share-toggle, .share-popup");
    shareTriggers.forEach(el => {
      el.style.pointerEvents = isOpen ? "none" : "";
      el.style.zIndex = isOpen ? "0" : "";
    });
  });
  observer.observe(document.body, { attributes: true, childList: true, subtree: true });

  /* 
     STICKY FILTER BAR TOGGLE
   */
  const filterToggle = section.querySelector(".toggle-filters");
  const filterDrawer = section.querySelector(".filter-drawer");
  if (filterToggle && filterDrawer) {
    filterToggle.addEventListener("click", () => {
      filterDrawer.classList.toggle("open");
      filterToggle.textContent = filterDrawer.classList.contains("open")
        ? "Hide Filters ▲"
        : "Filters ▾";
    });
  }
}
